/** Extensões dos arquivos  */
export interface ArquivoExtensao {
    id: number;
    nome: string;
    iconClass: string;
}

export const arquivoExtensaoTipoPDF: ArquivoExtensao = {
    id: 1,
    nome: 'PDF',
    iconClass: 'far fa-file-pdf'
};

export const arquivoExtensaoTipoTXT: ArquivoExtensao = {
    id: 2,
    nome: 'TXT',
    iconClass: 'far fa-file-alt'
};

export const arquivoExtensaoTipoZIP: ArquivoExtensao = {
    id: 3,
    nome: 'ZIP',
    iconClass: 'far fa-file-archive'
};

export const arquivoExtensaoTipoDOC: ArquivoExtensao = {
    id: 4,
    nome: 'DOC',
    iconClass: 'far fa-file-word'
};

export const arquivoExtensaoTipoPPT: ArquivoExtensao = {
    id: 5,
    nome: 'PPT',
    iconClass: 'far fa-file-powerpoint'
};

export const arquivoExtensaoTipoXLS: ArquivoExtensao = {
    id: 6,
    nome: 'XLS',
    iconClass: 'far fa-file-excel'
};

export const arquivoExtensaoTipoImagem: ArquivoExtensao = {
    id: 7,
    nome: 'Imagem',
    iconClass: 'far fa-file-image'
};

export const arquivoExtensaoTipoAudio: ArquivoExtensao = {
    id: 8,
    nome: 'Audio',
    iconClass: 'far fa-file-audio'
};

export const arquivoExtensaoTipoVideo: ArquivoExtensao = {
    id: 9,
    nome: 'Video',
    iconClass: 'far fa-file-video'
};

export const arquivoExtensaoTipoXML: ArquivoExtensao = {
    id: 10,
    nome: 'XML',
    iconClass: 'far fa-file-code'
};

export const arquivoExtensaoTipoOutra: ArquivoExtensao = {
    id: 99,
    nome: 'Outra',
    iconClass: 'far fa-file'
};

export const arquivosExtensoes: ArquivoExtensao[] = [
    arquivoExtensaoTipoPDF,
    arquivoExtensaoTipoTXT,
    arquivoExtensaoTipoZIP,
    arquivoExtensaoTipoDOC,
    arquivoExtensaoTipoPPT,
    arquivoExtensaoTipoXLS,
    arquivoExtensaoTipoImagem,
    arquivoExtensaoTipoAudio,
    arquivoExtensaoTipoVideo,
    arquivoExtensaoTipoXML,
    arquivoExtensaoTipoOutra
];


/** Verifica se a extensão é PDF */
export function isArquivoExtensaoPDF(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoPDF.id;
}

/** Verifica se a extensão é TXT */
export function isArquivoExtensaoTXT(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoTXT.id;
}


/** Verifica se a extensão é ZIP */
export function isArquivoExtensaoZIP(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoZIP.id;
}


/** Verifica se a extensão é DOC */
export function isArquivoExtensaoDOC(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoDOC.id;
}


/** Verifica se a extensão é PPT */
export function isArquivoExtensaoPPT(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoPPT.id;
}


/** Verifica se a extensão é XLS */
export function isArquivoExtensaoXLS(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoXLS.id;
}


/** Verifica se a extensão é Imagem */
export function isArquivoExtensaoImagem(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoImagem.id;
}


/** Verifica se a extensão é Audio */
export function isArquivoExtensaoAudio(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoAudio.id;
}


/** Verifica se a extensão é Video */
export function isArquivoExtensaoVideo(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoVideo.id;
}


/** Verifica se a extensão é XML */
export function isArquivoExtensaoXML(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoXML.id;
}


/** Verifica se a extensão é Outra */
export function isArquivoExtensaoOutra(extensao: number): boolean {
    if (!extensao) {
        return false;
    }
    return extensao === arquivoExtensaoTipoOutra.id;
}

function getFileExtension(filename: string): string {
    const match = filename.match(/(\.[^.]+)$/);
    return match ? match[0] : '';
}

/** Obtem a extensão de um arquivo através do seu nome do arquivo */
export function getExtensao(filename: string): ArquivoExtensao {
    // Extraindo a extensão do nome do arquivo
    const extension = getFileExtension(filename);
    switch (extension) {
        case '.pdf':
            return arquivoExtensaoTipoPDF;
        case '.txt':
            return arquivoExtensaoTipoTXT;
        case '.zip':
            return arquivoExtensaoTipoZIP;
        case '.rar':
            return arquivoExtensaoTipoZIP;
        case '.doc':
            return arquivoExtensaoTipoDOC;
        case '.docx':
            return arquivoExtensaoTipoDOC;
        case '.ppt':
            return arquivoExtensaoTipoPPT;
        case '.pptx':
            return arquivoExtensaoTipoPPT;
        case '.xls':
            return arquivoExtensaoTipoXLS;
        case '.xlsx':
            return arquivoExtensaoTipoXLS;
        case '.pps':
            return arquivoExtensaoTipoPPT;
        case '.jpg':
            return arquivoExtensaoTipoImagem;
        case '.jpge':
            return arquivoExtensaoTipoImagem;
        case '.png':
            return arquivoExtensaoTipoImagem;
        case '.gif':
            return arquivoExtensaoTipoImagem;
        case '.svg':
            return arquivoExtensaoTipoImagem;
        case '.ico':
            return arquivoExtensaoTipoImagem;
        case '.bmp':
            return arquivoExtensaoTipoImagem;
        case '.mp3':
            return arquivoExtensaoTipoAudio;
        case '.wma':
            return arquivoExtensaoTipoAudio;
        case '.mid':
            return arquivoExtensaoTipoAudio;
        case '.avi':
            return arquivoExtensaoTipoVideo;
        case '.mpg':
            return arquivoExtensaoTipoVideo;
        case '.mpge':
            return arquivoExtensaoTipoVideo;
        case '.mov':
            return arquivoExtensaoTipoVideo;
        case '.wmv':
            return arquivoExtensaoTipoVideo;
        case '.xml':
            return arquivoExtensaoTipoXML;
        default:
            return arquivoExtensaoTipoOutra;
    }
}

